import IconStopSolid from '@/assets/icons/font_awesome/ban-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_child_entity_share_status_update } from '@/state/workspace/child_entity/remote_workspace_child_entity_share_status_update';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { RequestWorkspaceChildEntityUpdateShareStatus } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_update_share_status';

interface Props {
  entity: DTO__workspace_child_enity;
}

export function WSWorkspaceChildEntityStopSharingButton({ entity }: Props) {
  const dispatch = use_dispatch();

  async function onClick() {
    let request = new RequestWorkspaceChildEntityUpdateShareStatus();
    request.workspace_id = entity.workspace_id;
    request.entity_type = entity.type;
    request.entity_id = entity._id;
    request.is_shared = false;

    await dispatch(remote_workspace_child_entity_share_status_update([request]));
  }

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      className="!w-5 !h-5 p-0"
      iconClassNameBase="!size-3"
      iconClassNameHovered={` !text-red-400`}
      iconClassNameNonHovered={` !text-red-700`}
      variant={'no-border-on-component'}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={IconStopSolid}
      {...{ onClick }}
    />
  );
}
